<template>
  <div>
    <div class="level">
      <div class="level-left">
        <button
          class="button is-info is-small"
          @click="triggerStateToOpenCreateEditModal"
        >
          <span class="icon"> <i class="fas fa-plus"></i> </span>&nbsp; Create
          new
        </button>
        &nbsp;
        <button class="button is-small" @click="refreshTable()">Refresh</button>
      </div>
      <div class="level-right">
        <b-select size="is-small" v-model="perPage">
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          <option value="20">20 per page</option>
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
          <option value="1000">1000 per page</option>
        </b-select>
      </div>
    </div>
    <table-pagination
      :tableData="productsOrServices.data"
      :search="search"
      :bordered="true"
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :mobileCards="true"
      :loading="isLoadingTable"
      :page="page"
      :perPage="perPage"
      :totalData="productsOrServices.totalData"
      @onPageChanged="page = $event"
      @onSearchChanged="search = $event"
      @onPerPageChanged="perPage = $event"
    >
      <template slot="row-content" slot-scope="{ item }">
        <b-table-column class="table-column-content-is-small" label="Name">
          {{ item.row.name }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Desc.">
          {{ item.row.desc }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="SKU">
          {{ item.row.sku }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Product type"
        >
          {{ item.row.productType }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Cost">
          {{ item.row.cost }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Qty on hand"
        >
          {{ item.row.qtyOnHand }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Date created"
        >
          {{ item.row.dateCreated }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button
            class="button is-small is-warning"
            @click="
              triggerStateToOpenCreateEditModal(item.row.productOrServiceId)
            "
          >
            Edit
          </button>
          &nbsp;
          <button
            class="button is-small is-danger"
            @click="
              deleteProductOrService(item.row.productOrServiceId, item.row.name)
            "
          >
            Delete
          </button>
        </b-table-column>
      </template>
    </table-pagination>
    <Delete />
    <CreateEdit />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TablePagination from "../TablePagination.vue";
import Delete from "./Delete.vue";
import CreateEdit from "./CreateEdit.vue";

export default {
  components: {
    TablePagination,
    Delete,
    CreateEdit,
  },
  mounted() {
    this.default();
  },
  computed: {
    ...mapState("productorservice", {
      productsOrServices: (state) => state.productsOrServices,
      productOrService: (state) => state.productOrService,
      isLoadingTable: (state) => state.isLoadingTable,
    }),
  },
  data: () => ({
    isEmpty: false,
    page: 1,
    perPage: 10,
    search: "",
  }),
  methods: {
    ...mapActions("productorservice", [
      "getPaginatedData",
      "openDeleteModal",
      "openCreateEditModal",
    ]),
    refreshTable() {
      this.default();
    },
    default() {
      this.getPaginatedData({
        page: this.page,
        pageSize: this.perPage,
        query: this.search,
      });
    },
    triggerStateToOpenCreateEditModal(id) {
      this.openCreateEditModal({
        showCreateOrEditModal: true,
        productOrServiceState: {
          productOrServiceId: id,
        },
      });
    },
    deleteProductOrService(id, name) {
      this.openDeleteModal({
        showDeleteModal: true,
        productOrServiceState: {
          productOrServiceId: id,
          name,
        },
      });
    },
  },
  watch: {
    perPage(val) {
      this.getPaginatedData({
        page: this.page,
        pageSize: val,
        query: this.search,
      });
    },
    page(val) {
      this.getPaginatedData({
        page: val,
        pageSize: this.perPage,
        query: this.search,
      });
    },
    search(val) {
      this.getPaginatedData({
        page: this.page,
        pageSize: this.perPage,
        query: val,
      });
    },
  },
};
</script>

